import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import { isEmpty,findIndex,isUndefined } from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const currencies = [
    {
        value: '',
        label:<IntlMessages id="Choose"/>
    },
    {
        value: "0",
        label: <IntlMessages id="appKontoModule.Create.new"/>
    }
];

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function InputComponent(props) {
    const classes = useStyles();
    const [currency, setCurrency] = React.useState("");
    const [Kontakter, setKontakter] = React.useState([]);
    const [CurrentKontakt, setCurrentKontakt] = React.useState(isEmpty(props.kontakt)?{}:props.kontakt);
    let placeholder = props.intl.formatMessage({ id: 'Role.PlaceHolder' });
    const [step, setStep] = React.useState(0);
    const kontakttt = "Kontakt"
    React.useEffect(() => {
        setKontakter(props.Kontakter)
        setStep(props.step)       
    });
    const handleChangeParas=(e)=>{
        setCurrentKontakt({
            ...CurrentKontakt,
            [e.target.name]:e.target.value
        })
        props.SetAvtalParameters({
            ...CurrentKontakt,
            [e.target.name]:e.target.value
        })
    }
    const handleChange = (event) => {
        setCurrency(event.target.value);
        if(isEmpty(event.target.value) || event.target.value === "0"|| event.target.value === 0 ){  
            setCurrentKontakt({})    
            props.SetAvtalParameters(CurrentKontakt)        
        }else{
            let Ckontakter = findIndex(Kontakter, function(o) { return o.id == event.target.value; })
            setCurrentKontakt(Kontakter[Ckontakter])
            props.SetAvtalParameters(Kontakter[Ckontakter])
        }
    };
    return (
        <div>
            <form className={classes.root}>
                <div>
                    <div className="row my-2"  style={{ height: 'auto' }}>
                        <div className="col-6">
                            <TextField
                                select
                                label={<IntlMessages id="Contact"/>}
                                variant="outlined"
                                size="small"
                                name="id"
                                value={currency}
                                fullWidth
                                onChange={(e)=>handleChange(e)}
                                SelectProps={{
                                    native: true,
                                }}
                                InputLabelProps={{
                                    shrink: true,}}
                            >

                                {currencies.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                                {
                                !isUndefined(Kontakter)?
                                Kontakter.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.fname} {option.lname}
                                    </option>
                                ))
                                :""
                                }
                                
                            </TextField>
                        </div>
                        <div className="col-6">
                            <TextField
                                label={<IntlMessages id="user.Role"/>}
                                fullWidth
                                value={isEmpty(CurrentKontakt.Role)?"":CurrentKontakt.Role}
                                onChange={(e)=>handleChangeParas(e)}
                                placeholder={placeholder}
                                size="small"
                                name="Role"
                                InputProps={{
                                    readOnly: parseInt(currency) ===0? false : true,
                                  }}
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                            />
                        </div>
                    </div>
                </div>
                <div className="row my-2"  style={{ height: 'auto' }}>
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="userProfile.firstName"/>}
                            placeholder=""
                            fullWidth
                            size="small"
                            margin="normal"
                            name="fname"
                            onChange={(e)=>handleChangeParas(e)}
                            value={isEmpty(CurrentKontakt.fname)?"":CurrentKontakt.fname}
                            InputProps={{
                                readOnly: parseInt(currency) ===0? false : true,
                              }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                        />
                    </div>
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="userProfile.lastName"/>}
                            fullWidth
                            placeholder=""
                            name="lname"
                            size="small"
                            margin="normal"
                            onChange={(e)=>handleChangeParas(e)}
                            value={isEmpty(CurrentKontakt.lname)?"":CurrentKontakt.lname}
                            InputProps={{
                                readOnly: parseInt(currency) ===0? false : true,
                              }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                        />
                    </div>
                </div>
                <div className="row my-2"  style={{ height: 'auto' }}>
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="userProfile.Telephone"/>}
                            fullWidth
                            placeholder="07..."
                            size="small"
                            margin="normal"
                            name="Tele"
                            onChange={(e)=>handleChangeParas(e)}
                            value={isEmpty(CurrentKontakt.Tele)?"":CurrentKontakt.Tele}
                            InputProps={{
                                readOnly: parseInt(currency) ===0? false : true,
                              }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                        />
                    </div>
                    <div className="col-6">
                        <TextField
                            label={<IntlMessages id="userProfile.email"/>}
                            fullWidth
                            placeholder=""
                            size="small"
                            margin="normal"
                            name="Email"
                            onChange={(e)=>handleChangeParas(e)}
                            value={isEmpty(CurrentKontakt.Email)?"":CurrentKontakt.Email}
                            InputProps={{
                                readOnly: parseInt(currency) ===0? false : true,
                              }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                        />
                    </div>
                </div>
                {
                         parseInt(currency) ===0?
                         <div className="row my-2"  style={{ height: 'auto' }}>
                         <div className="col-6">
                         <TextField
                             label={<IntlMessages id="userProfile.identityNr"/>}
                             fullWidth
                             placeholder=""
                             size="small"
                             margin="normal"
                             name="Personnummer"
                             onChange={(e)=>handleChangeParas(e)}
                             value={isEmpty(CurrentKontakt.Personnummer)?"":CurrentKontakt.Personnummer}
                             InputProps={{
                                 readOnly: parseInt(currency) ===0? false : true,
                               }}
                             InputLabelProps={{
                                 shrink: true,
                             }}
                             variant="outlined"
                         />
                     </div>
                     </div>
                         :""
                    }
            </form>
        </div>
    );
}
export default injectIntl(InputComponent);